import { ProductVariantOption } from '@shared/lib/shopify/types';
import assert from 'assert';

export function rPercentage(ratio: number | string): string {
  const numericRatio = typeof ratio === 'string' ? parseFloat(ratio) : ratio;
  assert(numericRatio >= 0 && numericRatio <= 1);
  return `${(numericRatio * 100).toFixed(0)}%`;
}

export function rOptionName(option: ProductVariantOption) {
  if (option.name === 'Size') {
    return 'Carat Weight';
  }
  if (option.name === 'Cut') {
    return 'Shape';
  }
  if (option.name === 'Precious Metal') {
    return 'Metal';
  }
  return option.name;
}

export function rNumber(number: number | string): string {
  const numericNumber = typeof number === 'string' ? parseFloat(number) : number;
  return numericNumber.toLocaleString('en-US', {
    // maximumFractionDigits: 0,
    useGrouping: true,
  });
}

export function rCarat(carat: number | string): string {
  if (typeof carat === 'string') {
    if (carat.includes('ct')) {
      return carat;
    }
    return `${carat} carat`;
  } else {
    if (carat === 0.25) {
      return '1/4 carat';
    }
    if (carat === 0.5) {
      return '1/2 carat';
    }
    if (carat === 0.75) {
      return '3/4 carat';
    }
    if (carat === 1) {
      return '1 carat';
    }
    if (carat === 1.5) {
      return '1 1/2 carat';
    }
    if (carat === 2) {
      return '2 carat';
    }
    if (carat === 3) {
      return '3 carat';
    }
    return (
      carat.toLocaleString('en-US', {
        maximumFractionDigits: 2,
        useGrouping: true,
      }) + ' carat'
    );
  }
}
